module.exports = __webpack_public_path__ + "static/img/bg.e96a1e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/user-classify/bg.png
// module id = wV8x
// module chunks = 1